import React, { useEffect, useState } from 'react'
import { decodeToken } from 'react-jwt';
import { useParams } from 'react-router-dom';

import Loader from '../../../Base/Components/Loader/Loader';
import { formatCodigoProveedor } from '../../../Base/Services/Format';
import { getLabel } from '../../../Base/Services/Language/LanguageService';

import { getProveedorInfo } from '../../../Base/API/Proveedores/ProveedoresRequest';
import { getBancosList } from '../../../Base/API/Global/Currency/CurrencyRequest';
import { getCountriesList } from '../../../Base/API/Countries/CountriesRequest';
import { getCurrencyToken } from '../../../Base/API/Global/Currency/CurrencyRequest';

import logo from '../../../Base/Assets/Logo_PPF_small.png'

import { InscripcionProveedoresLang } from './Lang/InscripcionProveedoresLang';

import './Styles/Proveedores.scss'
import './Styles/FormatoInscripcionProveedores.scss'

const FormatoInscripcionProveedor = () => {

    const { Token, lang } = useParams();

    const [loading, setLoading] = useState(false);
    const [data, setData] = useState({
        NombreComercial: '', // CustomerName
        numeroIdentificacionTributaria: '', //RTN
        Country: null, //Country
        State: '', //State
        City: '',
        Address: '', // DIRECCION COMERCIALBICBIC
        Tel: '', // TELEFONO DE REFERENCIA
        Email: '', // EMAIL
        PrincipalActividadEconomica: '',
        TipoFacturacion: null, // TIPO DE FACTURACION
        CasaMatriz: '',
        DireccionCasaMatriz: '',

        // CONTACTO REPRESENTANTE LEGAL
        NombreRepresentanteLegal: '',
        CorreoRepresentanteLegal: '',


        // CONTACTO CUENTAS POR COBRAR
        ContactoCuentasPorCobrar: '',
        CorreoCuentasPorCobrar: '',
        TelefonoCuentasPorCobrar: '',


        // INFORMACION BANCARIA HONDURAS
        NumeroCuentaBancaria: '',
        TitularCuenta: '',
        Banco: null,
        TipoCuenta: null,
        Currency: null,

        // INFORMACION BANCARIA EXTRANJERO
        // BANCO INTERMEDIARIO
        BancoIntermediarioNombre: '',
        BancoIntermediarioDireccion: '',
        BancoIntermediarioSwift: '',
        BancoIntermediarioAbaBin: '',
        BancoIntermediarioCuenta: '',
        // BANCO BENEFCIARIO
        BancoBeneficiarioNombre: '',
        BancoBeneficiarioDireccion: '',
        BancoBeneficiarioSwift: '',
        BancoBeneficiarioNombreBeneficiario: '',
        BancoBeneficiarioCuenta: '',
        BancoBeneficiarioAbaBin: '',



        // REFERENCIAS COMERCIALES
        ref1Nombre: '',
        ref1Telefono: '',
        ref1Correo: '',
        ref2Nombre: '',
        ref2Telefono: '',
        ref2Correo: '',



        // DOCUMENTACION
        FileRTN: null,
        FilePermisoOperaciones: null,
        FileNacional: null,
        FileEscrituraConstitucion: null,



        // AUTORIZACION
        AutorizacionDeposito: false,

        // ZONA LIBRE
        ZonaLibre: false,
        NombreZonaLibre: null,
        DireccionZonaLibre: null,
    });


    const setLabel = (label) => {
        return getLabel(InscripcionProveedoresLang, label, lang);
    }


    const tiposFactura = [
        { tipo: 'Facturación Electrónica', type: 'Electronic billing' },
        { tipo: 'Facturación Física', type: 'Physical billing' },
        { tipo: 'Boleta por honorarios profesionales', type: 'Invoice for professional services' },
    ]

    const tiposCuentas = [
        { tipo: 'Ahorros' },
        { tipo: 'Corriente' }
    ]


    const getCompanyInfo = async (IdCustomer) => {
        setLoading(true);
        const result = await getProveedorInfo(IdCustomer, Token);
        // console.log({Token});
        if (result.length > 0) {
            const bancosT = await getBancosList(Token);
            const contriesT = await getCountriesList(Token);
            const currenciesT = await getCurrencyToken(Token);
            const pais = contriesT.find(x => x.Id === result[0].IdCountry);
            const tipoFactura = tiposFactura.find(x => x.tipo === result[0].TipoFacturacion);
            const banco = bancosT.find(x => x.IdBanco === result[0].IdBanco);
            const tipoCuenta = tiposCuentas.find(x => x.tipo === result[0].TipoCuenta);
            const moneda = currenciesT.find(x => x.IdCurrency === result[0].IdCurrency);
            console.log(result);

            setData({
                ...result[0],
                NombreComercial: result[0].CustomerName,
                numeroIdentificacionTributaria: result[0].RTN,
                Country: pais,
                TipoFacturacion: tipoFactura,
                Banco: banco,
                TipoCuenta: tipoCuenta,
                Currency: moneda,
            });
        }
        setTimeout(() => {
            setLoading(false);
        }, 500);
    }



    useEffect(() => {
        const decoded = decodeToken(Token);
        if (decoded) {
            let { IdCustomer } = decoded;
            if (IdCustomer) {
                getCompanyInfo({ IdCustomer });
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

        return (
            <div className='pageSize col-12 OrdenesComprasReporte formatoInscripcionProveedores'>
                <Loader show={loading} querySelector='.formatoInscripcionProveedores' />
                {/* ENCABEZADO */}
                <div className='encabezadoPPF col-12 d-flex align-items-center justify-content-around' style={{ fontSize: 12 }}>
                    <div className='col-3'>
                        <img src={logo} alt="" width={180} />
                    </div>
                    <div className='col-6' style={{ lineHeight: 1.2 }}>
                        <span>ZONA LIBRE PRIDE PERFORMANCE FABRICS KM 19.5</span>
                        <br />
                        <span>CARRETERA A OCCIDENTE, LA ACEQUIA, NACO, QUIMISTÁN,</span>
                        <br />
                        <span>SANTA BÁRBARA, HONDURAS.</span>
                        <br />
                        <span>E-mail: info@ppf.com.hn</span>
                        <br />
                        <span>Teléfono: +504 2625-4400</span>
                    </div>
                    <div className='col-3 text-center' style={{ fontSize: 18 }}>
                        <strong>{setLabel('codigoProveedor')}</strong>
                        <br />
                        <strong>{formatCodigoProveedor(data.IdCustomer)}</strong>
                    </div>
                </div>

                <div className='titulo'>
                    <strong>{setLabel('Titulo')} PPF-PPCVI V1</strong>
                </div>

                <div className="col-12 d-flex justify-content-between mt-1">
                    <div className="col-4"><strong>{setLabel('tipoSolictud')}:</strong></div>
                    <div className="col-4 d-flex"><strong>{setLabel('Inscripción')}: </strong><div className='boxCheckbox'></div></div>
                    <div className="col-4 d-flex"><strong>{setLabel('Actualización')}: </strong><div className='boxCheckbox'></div></div>
                </div>

                <div className='barTitle mt-1 mb-2'>
                    <strong>{setLabel('parte')} I. {setLabel('informacionGeneral')}</strong>
                </div>

                <div className='info'>
                    <div className='parte' style={{ gridTemplateColumns: '1.3fr 1fr' }}>
                        <div className="input">
                            <strong>{setLabel('nombreCasaMatriz')}</strong>
                            <p>{data?.CasaMatriz}</p>
                        </div>
                        <div className="input">
                            <strong>{setLabel('paisConstitucion')}</strong>
                            <p>{(data?.Country?.Name)}</p>
                        </div>
                        <div className="input">
                            <div>
                                <strong>{setLabel('NombreComercial')}</strong>
                                <span> ({setLabel('distCasaMatriz')}):</span>
                            </div>
                            <p>{data?.NombreComercial}</p>
                        </div>
                        <div className="input">
                            <strong>{setLabel('NumIdentificacionTributaria')}: RTN/RUC/UTR/BRN/TAX ID</strong>
                            <p>{data?.RTN}</p>
                        </div>
                    </div>


                    <div className='mt-1'>
                        <div className="input">
                            <div>
                                <strong>{setLabel('DireccionComercial')}</strong>
                                <span> ({setLabel('siEsDistintoAnterior')}):</span>
                            </div>
                            <p>{data?.Address}</p>
                        </div>
                    </div>


                    <div className="parte" >
                        {/* TELEFONO DE REFERENCIA */}
                        <div className="input">
                            <strong>{setLabel('TelefonoRef')}:</strong>
                            <div className='inLine'>
                                <span style={{ marginRight: 15 }}>No.</span>
                                <p>{data.Tel}</p>
                            </div>
                        </div>
                        {/* CORREO DE REFERENCIA */}
                        <div className="input">
                            <div className='inLine'>
                                <span style={{ marginRight: 15 }}>E-mail:</span>
                                <p >{data.Email}</p>
                            </div>
                        </div>
                        {/* CONTACTO CUENTAS POR COBRAR */}
                        <div className="input">
                            <strong>{setLabel('ContactoCuentasPorCobrar')}:</strong>
                            <div className='inLine'>
                                <span >{setLabel('Nombre')}:</span>
                                <p>{data.ContactoCuentasPorCobrar}</p>
                            </div>
                        </div>
                        <div className="input">
                            <div className='inLine'>
                                <span style={{ marginRight: 15 }}>Email:</span>
                                <p>{data.CorreoCuentasPorCobrar}</p>
                            </div>
                        </div>
                        {/* REPRESENTANTE LEGAL */}
                        <div className="input">
                            <strong>{setLabel('representanteLegal')}:</strong>
                            <div className='inLine'>
                                <span style={{ marginRight: 5 }}>{setLabel('Nombre')}:</span>
                                <p>{data.NombreRepresentanteLegal}</p>
                            </div>
                        </div>
                        <div className="input">
                            <div className='inLine'>
                                <span style={{ marginRight: 15 }}>E-mail:</span>
                                <p>{data.CorreoRepresentanteLegal}</p>
                            </div>
                        </div>
                    </div>

                    {/* PRINCIPAL ACTIVIDAD ECONOMICA */}
                    <div className='mt-1'>
                        <div className="input">
                            <strong>{setLabel('actividadEconomica')}</strong>
                            <p>{data.PrincipalActividadEconomica}</p>
                        </div>
                    </div>
                </div>

                <div className='barTitle mt-1 mb-2'>
                    <strong>{setLabel('parte')} II.  {setLabel('referenciasComerciales').toUpperCase()}</strong>
                </div>

                {/* REFERENCIAS COMERCIALES */}
                <div className="info">
                    <div className="">
                        {/* REFERENCIA 1 */}
                        <div className='mt-1'>
                            <div className="input">
                                <strong>{setLabel('nombreCompañia')}</strong>
                                <p>{data.ref1Nombre}</p>
                            </div>
                        </div>
                        <div className="parte">
                            {/* TELEFONO */}
                            <div className="input">
                                <div className='inLine'>
                                    <strong>{setLabel('TelefonoSmall')}</strong>
                                    <p>{data.ref1Telefono}</p>
                                </div>
                            </div>
                            {/* CORREO */}
                            <div className="input">
                                <div className='inLine'>
                                    <span style={{ marginRight: 15 }}>E-mail:</span>
                                    <p>{data.ref1Correo}</p>
                                </div>
                            </div>
                        </div>


                        {/* REFERENCIA 2 */}
                        <div className='mt-1'>
                            <div className="input">
                                <strong>{setLabel('nombreCompañia')}</strong>
                                <p>{data.ref2Nombre}</p>
                            </div>
                        </div>
                        <div className="parte">
                            {/* TELEFONO */}
                            <div className="input">
                                <div className='inLine'>
                                    <strong>{setLabel('TelefonoSmall')}</strong>
                                    <p>{data.ref2Telefono}</p>
                                </div>
                            </div>
                            {/* CORREO */}
                            <div className="input">
                                <div className='inLine'>
                                    <span style={{ marginRight: 15 }}>E-mail:</span>
                                    <p>{data.ref2Correo}</p>
                                </div>
                            </div>
                        </div>


                    </div>
                </div>


                {/* INFORMACION BANCARIA  */}

                <div className='barTitle mt-1'>
                    <strong>{setLabel('parte')} III. {setLabel('informacionBancaria').toUpperCase()}</strong>
                </div>


                {data?.Country?.Id === 95 ?
                    <div>
                        <p style={{ margin: 0 }}>{setLabel('msgValidacionNacional')}</p>

                        {/* NUMERO DE CUENTA */}
                        <div className="input">
                            <div className="inLine">
                                <strong>{setLabel('cuentaBancariaNacional')}: </strong>
                                <p>{data.NumeroCuentaBancaria}</p>
                            </div>
                        </div>
                        {/*  A NOMBRE DE */}
                        <div className="input">
                            <div className="inLine">
                                <strong>{setLabel('aNombreDe')}: </strong>
                                <p>{data.TitularCuenta}</p>
                            </div>
                        </div>
                        {/* NOMBRE BANCO */}
                        <div className="parte">
                            <div className="input">
                                <div className="inLine">
                                    <strong>{setLabel('Banco')}: </strong>
                                    <p>{data.Banco.NombreBanco}</p>
                                </div>
                            </div>
                            {/* RTN */}
                            <div className="input">
                                <div className="inLine">
                                    <strong>{setLabel('RTN')}: </strong>
                                    <p>{data.RTN}</p>
                                </div>
                            </div>
                            {/* TIPO CUENTA */}
                            <div className="input">
                                <div className="inLine">
                                    <strong>{setLabel('tipoCuenta')}: </strong>
                                    <p>{data.TipoCuenta?.tipo}</p>
                                </div>
                            </div>
                            {/* MONEDA */}
                            <div className="input">
                                <div className="inLine">
                                    <strong>{setLabel('Moneda')}: </strong>
                                    <p>{data.Currency.Currency}</p>
                                </div>
                            </div>
                        </div>
                        {/* CORREO CUENTAS POR COBRAR */}
                        <div className="input">
                            <div className="inLine">
                                <strong>{setLabel('CorreoNotificacionPago')}: </strong>
                                <p>{data.CorreoCuentasPorCobrar}</p>
                            </div>
                        </div>

                        <div className='parte'>
                            {/* TELEFONO */}
                            <div className="input">
                                <div className="inLine">
                                    <strong>{setLabel('TelefonoSmall')}: </strong>
                                    <p>{data.TelefonoCuentasPorCobrar}</p>
                                </div>
                            </div>
                        </div>

                    </div> : <div>


                        <div>
                            <p style={{ margin: 0 }}>{setLabel('msgValidacion')}</p>
                        </div>

                        {/* BANCO INTERMEDIARIO */}
                        <div className='text-center'>
                            <strong>
                                {setLabel('bancoIntermediario').toUpperCase()}
                            </strong>
                        </div>

                        <div className="info">
                            {/* NOMBRE BANCO */}
                            <div className="input">
                                <div className="inLine">
                                    <strong>{setLabel('nombreBanco')}: </strong>
                                    <p>{data.BancoIntermediarioNombre}</p>
                                </div>
                            </div>
                            {/* DIRECCCION BANCO */}
                            <div className="input">
                                <div className="inLine">
                                    <strong>{setLabel('direccionBanco')}: </strong>
                                    <p>{data.BancoIntermediarioDireccion}</p>
                                </div>
                            </div>
                            {/* NUMERO DE CUENTA */}
                            <div className="input">
                                <div className="inLine">
                                    <strong>{setLabel('numeroCuenta')}: </strong>
                                    <p>{data.BancoIntermediarioCuenta}</p>
                                </div>
                            </div>

                            <div className="parte">
                                {/* Swift */}
                                <div className="input">
                                    <div className="inLine">
                                        <strong>{setLabel('Swift')}: </strong>
                                        <p>{data.BancoIntermediarioSwift}</p>
                                    </div>
                                </div>
                                {/* ABA */}
                                <div className="input">
                                    <div className="inLine">
                                        <strong>ABA: </strong>
                                        <p>{data.BancoIntermediarioAbaBin}</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* BANCO BENEFICIARIO */}
                        <div className='text-center mt-1'>
                            <strong>
                                {setLabel('bancoBeneficiario').toUpperCase()}
                            </strong>
                        </div>

                        <div className="info">
                            {/* NOMBRE BENEFICIARIO */}
                            <div className="input">
                                <div className="inLine">
                                    <strong>{setLabel('nombreBeneficiario')}: </strong>
                                    <p>{data.BancoBeneficiarioNombreBeneficiario}</p>
                                </div>
                            </div>
                            {/* NOMBRE BANCO */}
                            <div className="input">
                                <div className="inLine">
                                    <strong>{setLabel('nombreBanco')}: </strong>
                                    <p>{data.BancoBeneficiarioNombre}</p>
                                </div>
                            </div>
                            {/* DIRECCCION BANCO */}
                            <div className="input">
                                <div className="inLine">
                                    <strong>{setLabel('direccionBanco')}: </strong>
                                    <p>{data.BancoBeneficiarioDireccion}</p>
                                </div>
                            </div>
                            {/* NUMERO DE CUENTA */}
                            <div className="input">
                                <div className="inLine">
                                    <strong>{setLabel('numeroCuenta')}: </strong>
                                    <p>{data.BancoBeneficiarioCuenta}</p>
                                </div>
                            </div>

                            <div className="parte">
                                {/* Swift */}
                                <div className="input">
                                    <div className="inLine">
                                        <strong>{setLabel('Swift')}: </strong>
                                        <p>{data.BancoBeneficiarioSwift}</p>
                                    </div>
                                </div>
                                {/* ABA */}
                                <div className="input">
                                    <div className="inLine">
                                        <strong>ABA: </strong>
                                        <p>{data.BancoBeneficiarioAbaBin}</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>}


                <div className='mt-4'>
                    <p>{setLabel('declaracion')}</p>
                    <p>{setLabel('msgContacto')}	<strong>+504 9439-9000</strong></p>
                </div>


            </div>
        )

}

export default FormatoInscripcionProveedor